import {AssistantError} from './AssistantError.js'

export class StartNewChatAssistantError extends AssistantError {
  static create(message) {
    return new StartNewChatAssistantError(message)
  }
}
